import { AnyAction } from "redux";
import { initialState } from "./globalUI.initialState";
import * as types from "./globalUI.actionTypes";
import { Plan, Plan2 } from "types/plan.type";

export default (state = initialState, action: AnyAction) => {
  switch (action.type) {
    case types.SET_PLANS: {
      return {
        ...state,
        plans: action.payload.plans.map((plan) => new Plan(plan)),
      };
    }

    case types.SET_YEARLY_PLAN: {
      return {
        ...state,
        yearlyPlan: new Plan2(action.payload.plan),
      };
    }

    case types.SET_LOADING: {
      return {
        ...state,
        loading: action.payload.loading,
      };
    }
    default:
      return state;
  }
};
